<script setup lang="ts">
const { t } = useI18n();
</script>

<template>
  <div class="flex flex-col gap-6 w-full">
    <div class="text-gray-800 text-big">
      <p>
        This agreement is concluded between the limited liability company Ortho DGT,
        registration number: 40203578585, with its registered office at Skanstes iela 50c, Riga, Latvia, LV-1013 (hereinafter referred to as the &quot;Seller&quot;), on the one hand,
        and
        a healthcare professional (provider of medical services), who, by using the order
        form available in the “Products” section of the website https://orthodgt.com/
        (hereinafter referred to as the &quot;Website&quot;),
        expresses the intention to purchase, places an order for, or purchases any of the
        goods listed in the “Products” section of the Website (hereinafter referred to as the
        &quot;Goods&quot;), on the other hand.
        Together, both parties are hereinafter referred to as the &quot;Parties&quot;, and hereby enter
        into this Distance Contract (hereinafter referred to as the &quot;Contract&quot;).
      </p>

      <ul class="list-disc list-inside">
        <li>
          This Contract is a legally binding document that establishes the mutual rights,
          obligations, responsibilities, and other terms between the Buyer and the Seller
          regarding the purchase and sale of Goods offered by the Seller through the Website.
        </li>
        <li>
          The Buyer may purchase Goods through the Website only by agreeing to the
          Terms. By confirming that the Terms have been read, the Buyer undertakes to
          comply with them. When purchasing Goods from the Store, the Buyer agrees to the
          Terms and confirms their understanding.
        </li>
        <li>
          Section 1 of this Contract sets out the general procedure for purchasing all Goods
          from the Seller. Section 2 contains specific terms for individual Goods, while Section
          5 includes provisions applicable to all types of Goods ordered via the Website.
        </li>
        <li>
          These Contract Terms do not apply to goods or services that are not ordered
          through the Website and are provided under a separate agreement between the
          Seller and the client.
        </li>
        <li>
          These Terms do not apply to the informational content on the Website that is
          available to users free of charge.
        </li>
        <li>
          This Contract is governed by Cabinet Regulation No. 255 “Regulations Regarding
          Distance Contracts,” adopted on May 20, 2014.
        </li>
        <li>
          The Seller reserves the right to amend these Terms. Amendments become effective
          upon their publication on the Website and apply only to orders placed after the
          changes have been made. The Seller shall inform the Buyer of any amendments (e.g.,
          by posting updates in the Buyer&#39;s account and/or publishing them on the Website). If
          the Buyer continues to use the Website after the publication of the amendments,
          this shall be deemed as acceptance of all updated Terms.
        </li>
      </ul>
    </div>

    <div class="flex flex-col gap-4">
      <div class="text-h4 text-gray-900 font-semibold">
        1. General Terms for Ordering, Delivery, and Payment of Goods.
      </div>
      <div class="text-big text-gray-800">
        <p>
          1.1. The Seller offers and will continue to offer various types of dental products on
          the Website, under the “Products” section.
        </p>

        <p>
          1.2. Currently, all Goods on the Website are offered for a one-time payment only (no
          recurring payments).
        </p>
        <p>1.3. The following terms apply to the Buyer when purchasing dental products:</p>
        <p>
          1.3.1. To access certain Goods offered by the Seller, the Buyer must confirm that
          they are a qualified/certified specialist. Registration on the Website and creation of a
          personal account may be required. Before registering, the Buyer is expected to read
          the Website’s Privacy Policy. By registering, the Buyer is deemed to have read and
          accepted the Privacy Policy.
        </p>
        <p>
          1.3.1.1. During registration, the user must provide the necessary data and
          confirm that the submitted information is true and accurate. Registration is also
          possible using existing Google or Apple accounts through their authentication
          systems.
        </p>
        <p>
          1.3.1.2. The user is responsible for maintaining the confidentiality of their login
          credentials and password.
        </p>
        <p>
          1.3.2. Goods can be ordered and purchased (including delivery) by making a
          payment via bank card or transfer, available 24/7.
        </p>
        <p>
          1.3.3. The Buyer reviews the Goods on the Website, including descriptions and
          prices, and selects the desired product by clicking on its name. The Website then
          displays a detailed description and key information. The Buyer evaluates whether
          the product meets their needs and makes any necessary customizations.
        </p>
        <p>
          1.3.4. To proceed with a purchase, the Buyer clicks “Select” and then chooses the
          required product customizations. Additional options may be selected, files may be
          uploaded, or the purchase can be finalized.
        </p>
        <p>
          1.3.5. To complete the purchase, the Buyer clicks on the cart icon located at the
          bottom of the Website&#39;s menu panel, where the total purchase amount is displayed.
          By opening the cart section, the Buyer sees all selected items, their individual prices,
          quantities, total cost, and applicable VAT (“Cart Summary”).
        </p>
        <p>
          1.3.6. To finalize the selected items, the Buyer clicks “Reserve” or “Approve
          design.” A submission form opens on the Website where all required fields must be
          filled out. The Buyer must confirm that the cart contents match their needs and that
          the selected customizations are accurate. Information on personal data processing is
          available in the Seller’s Privacy Policy and applies to all submitted personal data.
        </p>
        <p>
          1.3.7. When purchasing any Goods, the Buyer shall make payment using PayPal or by
          credit or debit card. Payment cannot be completed unless the Buyer confirms that:
        </p>
        <p>
          1.3.7.1. they agree to the terms of this Contract (by checking the box “I have read
          and agree to the Distance Contract” after reading it on the Website);
        </p>
        <p>1.3.7.2. they are a qualified/certified specialist;</p>
        <p>1.3.7.3. they have accepted the Seller’s Privacy Policy.</p>
        <p>1.3.8. Payment via PayPal:</p>
        <p>
          1.3.8.1. To pay for the order using PayPal, click &quot;Buy Now&quot; and you will be
          automatically redirected to PayPal. If you already have a PayPal account, you may

          log in to complete the payment. If you do not, you may check out as a guest or
          create a new account. Please note that mobile PayPal payments are supported only
          on devices with Android version 6.145.0 or later, or iOS version 6.143.0 or later. If
          your phone does not support these versions, you can complete the transaction using
          a desktop browser.
        </p>
        <p>
          1.3.8.2. PayPal direct payment offers a convenient way to complete your purchase
          directly on the Website. If you are using this method for the first time, you will be
          redirected to PayPal to authorize the payment. On future purchases, clicking “Buy
          Now” will complete your order. You can choose to save your payment method by
          checking the “Save payment method for future use” box. If you wish to disable this
          feature, you may delete and reconfigure your payment method. Please remember to
          uncheck the box if desired.
        </p>
        <p>
          1.3.8.3. If an order is canceled or returned, the refunded amount will be
          automatically transferred back to the PayPal account used for payment. The funds
          will either be returned directly to your PayPal account or redirected according to
          your selected payment method settings in PayPal.
        </p>
        <p>1.3.9. Payment by credit or debit card is processed via PayPal.</p>
        <p>1.3.9.1. Before using this method, ensure that:</p>
        <p>1.3.9.1.1. your card allows online transactions;</p>
        <p>1.3.9.1.2. you confirm the payment if prompted by your bank.</p>
        <p>1.3.9.2. To complete a card payment:</p>
        <p>1.3.9.2.1. select “Debit or Credit Card” as your payment method;</p>
        <p>1.3.9.2.2. enter the required information;</p>
        <p>1.3.9.2.3. click “Agree and Pay.”</p>
        <p>
          1.3.10. The invoice for Goods is issued electronically and is valid without a signature.
          To receive the Goods, the Buyer must pay the invoice in full by the due date
          indicated on the invoice and include the invoice-contract number (located on the
          right-hand side of the invoice) in the payment reference.
        </p>
        <p>
          1.3.11. In the event of any payment interruption, the payment process must be
          restarted. If the invoice is not paid by the specified date, or if it is only partially paid,
          it will be canceled, and the purchase process must begin again. If payment is made
          after cancellation, the Seller will contact the Buyer to clarify how to proceed with the
          paid amount.
        </p>
        <p>
          1.3.12. Upon successful payment, the invoice will automatically be sent to the
          Buyer’s email in PDF format, containing the information provided in the order form.
        </p>
        <p>
          1.3.13. Finalized contracts are not accessible later via the Website. The invoice in
          PDF format serves as the official confirmation of the concluded Contract.
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="text-h4 text-gray-900 font-semibold">
        2. Specific Terms for the Purchase of Goods
      </div>
      <div class="text-big text-gray-800">
        <p>
          2.1. Upon receiving the completed submission form, the Seller automatically sends
          an invoice to the email address provided by the Buyer. This invoice forms an integral
          part of this Contract. It is issued electronically and remains valid without a signature.
          Production of the ordered Goods will begin only after full payment has been made
          within the specified deadline, using the invoice number as the payment reference.
          Once payment is received, the Seller will send a link to view the order, along with the
          invoice, to the email address provided by the Buyer’s representative.
        </p>
        <p>
          2.2. The Seller will send the Buyer information about the reservation of goods or any
          other relevant details via email. The Seller’s confirmation is considered a reservation
          only. Production will begin only after the Buyer has fully paid for the Goods as per
          the invoice.
        </p>
        <p>
          2.3. In accordance with Paragraph 22.3 of Cabinet Regulation No. 255 “Regulations
          Regarding Distance Contracts,” adopted on May 20, 2014, the Buyer does not have
          the right to withdraw from the purchase after placing the order and paying for the
          Goods.
        </p>
        <p>
          2.4. If the Buyer fails to pay the invoice within the specified deadline without prior
          notice, the invoice will be automatically canceled.
        </p>
        <p>
          2.5. Should the Seller postpone the production schedule, the Buyer will be informed
          in a timely manner. In such cases, the Buyer has the right to reject the new schedule
          and receive a refund.
        </p>
        <p>
          2.6. The service of producing the Goods is considered fulfilled once the Buyer has
          received all ordered Goods.
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="text-h4 text-gray-900 font-semibold">
        3. Rights and Obligations of the Parties
      </div>
      <div class="text-big text-gray-800">
        <p>3.1. The Buyer undertakes to:</p>
        <p>
          3.1.1. Review the Website’s Contract Terms, Privacy Policy, and Cookie Policy
          before placing each order;
        </p>
        <p>
          3.1.2. Provide true and accurate information when placing any order to allow the
          Seller to fulfill it in full and issue an invoice;
        </p>
        <p>
          3.1.3. Confirm that any product customizations made on the Website meet their
          needs and are correct and appropriate;
        </p>
        <p>
          3.1.4. Pay for the production of goods in a timely manner, according to the terms
          and deadline stated in the invoice;
        </p>
        <p>
          3.1.5. The Buyer may authorize a third party to make payment via bank transfer
          on their behalf, provided that the invoice number is included in the payment
          reference.
        </p>
        <p>3.2. The Buyer has the right to:</p>
        <p>
          3.2.1. Receive the goods in accordance with the provided product descriptions and
          specifications;
        </p>
        <p>3.2.2. Contact the Seller for clarification if any uncertainties arise;</p>
        <p>3.2.3. Exercise the rights granted to the Buyer under this Contract.</p>
        <p>3.3. The Seller undertakes to:</p>
        <p>
          3.3.1. Fulfill the service and deliver the manufactured goods to the Buyer in
          accordance with the product descriptions;
        </p>
        <p>3.3.2. Provide complete and accurate information about the goods;</p>
        <p>
          3.3.3. Promptly inform the Buyer (including electronically) of any changes to the
          order fulfillment terms, should production deadlines change during the process;
        </p>
        <p>
          3.3.4. Review any complaints regarding received goods and provide the Buyer with
          a written response in accordance with applicable legal requirements;
        </p>
        <p>
          3.3.5. Comply with Regulation (EU) 2016/679 of the European Parliament and of
          the Council of 27 April 2016 on the protection of natural persons with regard to the
          processing of personal data and on the free movement of such data (General Data
          Protection Regulation), as well as applicable national laws of the Republic of Latvia
          on personal data protection;
        </p>
        <p>
          3.3.6. Adhere to Regulation (EU) 2017/745 of the European Parliament and of the
          Council of 5 April 2017 on medical devices, which amends Directive 2001/83/EC,
          Regulation (EC) No. 178/2002, and Regulation (EC) No. 1223/2009 and repeals
          Council Directives 90/385/EEC and 93/42/EEC (applicable within the EEA).
        </p>
        <p>3.4. The Seller has the right to:</p>
        <p>
          3.4.1. Contact the Buyer using the provided contact details to clarify any
          information about the selected goods or product description, if necessary after
          receiving an order;
        </p>
        <p>
          3.4.2. Withhold order fulfillment if payment has not been received in accordance
          with the specified terms.
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="text-h4 text-gray-900 font-semibold">
        4. Complaint Handling Procedure.
      </div>
      <div class="text-big text-gray-800">
        <p>
          4.1. Only Buyers who have initiated and submitted a product order or completed
          payment to the Seller are entitled to submit complaints. Visitors to the Website who
          have not placed an order may only submit suggestions.
        </p>
        <p>
          4.2. If the Buyer has a complaint regarding the quality of the goods, they must
          submit a written application to the Seller either by sending a registered letter to the
          Seller’s legal address or via email, signed with a secure electronic signature or sent
          through an official electronic address.
        </p>
        <p>
          4.3. The Seller will review the received complaint within 10 (ten) days. If, in
          accordance with Section 1 of this Contract, the complaint is deemed justified, the
          Seller shall take all necessary actions to resolve the issues stated in the complaint
          within 1 (one) month from the date of receipt.
        </p>
        <p>
          4.4. The Seller also responds to unsigned submissions (e.g., via email or phone)
          substantively. However, in such cases, no personal data will be disclosed, and no
          withdrawal rights or other personal claims will be processed.
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="text-h4 text-gray-900 font-semibold">
        5. Liability.
      </div>
      <div class="text-big text-gray-800">
        <p>
          5.1. The Parties are liable to each other for direct losses caused by the willful
          misconduct or gross negligence of the responsible Party. The burden of proving the
          existence of such losses lies with the Party seeking compensation. In all cases, the
          Service Provider’s liability shall not exceed the amount paid by the Buyer to the
          Seller for the specific Service in question.
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="text-h4 text-gray-900 font-semibold">
        6. Dispute Resolution.
      </div>
      <div class="text-big text-gray-800">
        <p>
          6.1. Any disputes or disagreements that may arise between the Parties in connection
          with this Contract shall be resolved through mutual negotiations.
        </p>
        <p>
          6.2. If a dispute cannot be resolved through negotiations within 30 (thirty) days, it
          may be referred to a court in accordance with the applicable laws of the Republic of
          Latvia.
        </p>
        <p>
          6.3. If the Seller considers the Buyer’s complaint to be unfounded, and the Buyer
          disagrees with this assessment or is dissatisfied with the Seller’s proposed
          resolution, the Buyer has the right to pursue alternative dispute resolution as
          provided under the Consumer Rights Protection Law of the Republic of Latvia, or to
          bring a claim against the Seller in a competent court of the Republic of Latvia in
          accordance with the applicable legislation.
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="text-h4 text-gray-900 font-semibold">
        7. Right of Withdrawal.
      </div>
      <div class="text-big text-gray-800">
        <p>
          7.1. The Buyer, as a consumer, has the right to withdraw from this Contract within
          14 (fourteen) days from the date of placing the order (i.e., when the invoice is issued
          and sent), without stating a reason, but no later than 14 (fourteen) days from the
          date the Contract is concluded—except in cases where the production of the Goods
          has already been completed during the withdrawal period; in such cases, withdrawal
          rights under applicable laws and this Contract do not apply.
        </p>
        <p>
          7.2. The withdrawal period begins on the day the Contract is concluded, which is the
          moment the Buyer places an order for Goods in the “Products” section by clicking
          “Reserve.” The withdrawal deadline is met if the Buyer sends a notice of withdrawal
          before the 14-day period expires.
        </p>
        <p>
          7.3. To exercise the right of withdrawal, the Buyer must notify the Seller of the
          decision by sending a properly completed withdrawal form (attached to this
          Contract) or an unambiguous free-form statement to the Seller’s email address:<a
            class="text-big font-medium text-gray-900 hover:text-blue-500 active:translate-y-[1px]"
            href="mailto:orthodgt@gmail.com"
          >orthodgt@gmail.com</a>
          . The notice must include the Buyer’s name, surname, email
          address, and physical address.
        </p>
        <p>
          7.4. If the Buyer exercises the right of withdrawal within the legal timeframe, this
          Contract is considered terminated, and the Seller will refund the payments received
          from the Buyer within 14 (fourteen) days from the day the Seller was informed of
          the withdrawal. Refunds will be issued using the same payment method originally
          used by the Buyer, unless the Buyer explicitly requests otherwise and provides full
          refund details. The Service Provider is not liable for any incorrect or mismatched
          payment details submitted by the Buyer, and any amount refunded to an incorrect
          account due to such errors will not be reissued.
        </p>
        <p>
          7.5. Upon receiving a withdrawal request, the Seller will immediately confirm its
          receipt by sending a notification to the email address specified in the Buyer’s
          withdrawal form or free-form notice.
        </p>
        <p>
          7.6. The Buyer can find additional information about the right of withdrawal on the
          website of the Consumer Rights Protection Centre: <a
            href="https://www.ptac.gov.lv/lv"
            class="text-big font-medium text-gray-900 hover:text-blue-500 active:translate-y-[1px]"
          >https://www.ptac.gov.lv/lv</a> The
          withdrawal form is available there as well.
        </p>
      </div>
    </div>

    <div class="flex flex-col gap-4">
      <div class="text-h4 text-gray-900 font-semibold">
        8. Other Provisions.
      </div>
      <div class="text-big text-gray-800">
        <p>
          8.1. This Contract enters into force once the Buyer has placed an order for Goods in
          accordance with the terms of the Contract and has received an invoice (or has
          completed payment via internet banking or payment card). The Contract remains
          valid until all obligations are fulfilled.
        </p>
        <p>
          8.2. By confirming agreement to these Contract Terms prior to making payment, the
          Buyer acknowledges that all terms have been clearly understood and agrees to
          comply with them in full.
        </p>
        <p>
          8.3. The Seller reserves the right to unilaterally amend or supplement the terms at
          any time without prior notice by publishing the updated terms in the relevant
          section of the Website. The version of the Terms in force at the time the Service is
          initiated shall apply to the Buyer.
        </p>
        <p>
          8.4. Any matters not governed by this Contract shall be subject to the applicable
          laws and regulations of the Republic of Latvia.
        </p>
        <p>
          8.5. If any provision of this Contract is deemed invalid, it shall not affect the validity
          of the remaining provisions.
        </p>
      </div>
    </div>
  </div>
</template>

<style scoped>

</style>
